module.exports = __webpack_public_path__ + "img/v3-halfsun.0df70895.svg";